import {WorkflowOption, WorkflowType} from "./types";

export const WORKFLOW_OPTIONS: Record<WorkflowType, WorkflowOption> = {
  [WorkflowType.ADMISSION]: {
    type: WorkflowType.ADMISSION,
    label: "Admission",
  },
  [WorkflowType.ARBITRATION]: {
    type: WorkflowType.ARBITRATION,
    label: "Arbitration",
  },
};

/** Static labels for known workflow types; facility-specific lists come from WorkflowService. */
